import { Office } from "@gettactic/api";
import { DEFAULT_TIME_SETTINGS } from "@gettactic/api";
import { camelizeKeys } from "../objects/camelizeKeys";
import { calculateEndTimeFromDuration } from "../date-time/calculateEndTimeFromDuration";

type ReservationTimeSettings = {
  startHour: number;
  startMinutes: number;
  endHour: number;
  endMinutes: number;
  deskDuration: number;
  meetingRoomDuration: number;
}

export const getDefaultsHoursFromOffice = (
  office: Office | null
): ReservationTimeSettings => {
  const baseSettings = office
    ? camelizeKeys(office.settings?.reservation_default_time || DEFAULT_TIME_SETTINGS)
    : camelizeKeys(DEFAULT_TIME_SETTINGS);
  
  const settings = baseSettings as {
    startHour: number;
    startMinutes: number;
    deskDuration: number;
    meetingRoomDuration: number;
  };
  
  // Calculate endHour and endMinutes from startHour, startMinutes, and deskDuration
  const { endHour, endMinutes } = calculateEndTimeFromDuration(
    settings.startHour,
    settings.startMinutes,
    settings.deskDuration
  );
  
  return {
    ...settings,
    endHour,
    endMinutes
  };
};
